/** IANA timezones for admin jurisdiction / clinic forms (value stored as IANA id). */
export const ADMIN_TIMEZONE_OPTIONS = [
  { value: "Europe/Paris", label: "Europe/Paris (CET)" },
  { value: "Europe/London", label: "Europe/London (GMT)" },
  { value: "Europe/Berlin", label: "Europe/Berlin (CET)" },
  { value: "Europe/Madrid", label: "Europe/Madrid (CET)" },
  { value: "Europe/Rome", label: "Europe/Rome (CET)" },
  { value: "Europe/Brussels", label: "Europe/Brussels (CET)" },
  { value: "Europe/Amsterdam", label: "Europe/Amsterdam (CET)" },
  { value: "Europe/Zurich", label: "Europe/Zurich (CET)" },
  { value: "Europe/Istanbul", label: "Europe/Istanbul (TRT)" },
  { value: "Europe/Moscow", label: "Europe/Moscow (MSK)" },
  { value: "Africa/Casablanca", label: "Africa/Casablanca (WET)" },
  { value: "Africa/Tunis", label: "Africa/Tunis (CET)" },
  { value: "Africa/Algiers", label: "Africa/Algiers (CET)" },
  { value: "Africa/Cairo", label: "Africa/Cairo (EET)" },
  { value: "Africa/Lagos", label: "Africa/Lagos (WAT)" },
  { value: "Africa/Johannesburg", label: "Africa/Johannesburg (SAST)" },
  { value: "Africa/Nairobi", label: "Africa/Nairobi (EAT)" },
  { value: "Africa/Brazzaville", label: "Africa/Brazzaville (WAT)" },
  { value: "Africa/Kinshasa", label: "Africa/Kinshasa (WAT)" },
  { value: "Africa/Dakar", label: "Africa/Dakar (GMT)" },
  { value: "Africa/Abidjan", label: "Africa/Abidjan (GMT)" },
  { value: "America/New_York", label: "America/New_York (EST)" },
  { value: "America/Chicago", label: "America/Chicago (CST)" },
  { value: "America/Denver", label: "America/Denver (MST)" },
  { value: "America/Los_Angeles", label: "America/Los_Angeles (PST)" },
  { value: "America/Toronto", label: "America/Toronto (EST)" },
  { value: "America/Sao_Paulo", label: "America/Sao_Paulo (BRT)" },
  { value: "America/Mexico_City", label: "America/Mexico_City (CST)" },
  { value: "America/Buenos_Aires", label: "America/Buenos_Aires (ART)" },
  { value: "America/Bogota", label: "America/Bogota (COT)" },
  { value: "Asia/Dubai", label: "Asia/Dubai (GST)" },
  { value: "Asia/Riyadh", label: "Asia/Riyadh (AST)" },
  { value: "Asia/Beirut", label: "Asia/Beirut (EET)" },
  { value: "Asia/Kolkata", label: "Asia/Kolkata (IST)" },
  { value: "Asia/Shanghai", label: "Asia/Shanghai (CST)" },
  { value: "Asia/Tokyo", label: "Asia/Tokyo (JST)" },
  { value: "Asia/Seoul", label: "Asia/Seoul (KST)" },
  { value: "Asia/Singapore", label: "Asia/Singapore (SGT)" },
  { value: "Asia/Bangkok", label: "Asia/Bangkok (ICT)" },
  { value: "Asia/Jakarta", label: "Asia/Jakarta (WIB)" },
  { value: "Australia/Sydney", label: "Australia/Sydney (AEDT)" },
  { value: "Australia/Melbourne", label: "Australia/Melbourne (AEDT)" },
  { value: "Pacific/Auckland", label: "Pacific/Auckland (NZDT)" },
  { value: "UTC", label: "UTC" },
];
